import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOracle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 23,
	height: 24,
	viewBox: "0 0 23 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.60057 0.395718L1.52109 4.92039C1.05857 5.17976 0.674552 5.55254 0.407565 6.00132C0.140578 6.45009 2.09759e-05 6.95907 0 7.47717V16.5228C0.000547884 17.0408 0.141551 17.5495 0.408865 17.9979C0.676179 18.4464 1.0604 18.8188 1.52299 19.0778L9.60057 23.6043C10.0636 23.8635 10.5889 24 11.1236 24C11.6582 24 12.1835 23.8635 12.6466 23.6043L20.7279 19.0796C21.1905 18.8206 21.5747 18.4482 21.8421 17.9998C22.1094 17.5514 22.2504 17.0426 22.2509 16.5247V7.47717C22.2504 6.95921 22.1094 6.45049 21.8421 6.00205C21.5747 5.55361 21.1905 5.18122 20.7279 4.92224L12.6466 0.395718C12.1835 0.136479 11.6582 0 11.1236 0C10.5889 0 10.0636 0.136479 9.60057 0.395718Z",
		fill: "#C74634"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.04459 17C5.24218 17 3 14.7776 3 12C3 9.22236 5.24218 7 8.04459 7H13.9554C16.7578 7 19 9.22236 19 12C19 14.7776 16.7578 17 13.9554 17H8.04459ZM13.8026 15.232C15.6369 15.232 17.0638 13.7672 17.0638 11.9996C17.0638 10.232 15.586 8.7672 13.8026 8.7672H8.19738C6.36306 8.7672 4.93618 10.232 4.93618 11.9996C4.93618 13.7672 6.41399 15.232 8.19738 15.232H13.8026Z",
		fill: "white"
	})]
});
export default SvgOracle;
